import { SerializedError } from '@reduxjs/toolkit'

import { ReservationAPIError } from '../types'

/**
 * The reservation service's kebab-case error code (e.g. `reservation-unavailable`)
 * from a serialized thunk error, or null
 */
export default function getReservationErrorCode(
  error: SerializedError | null | undefined,
): string | null {
  const data = (
    error as (SerializedError & { response?: { data?: unknown } }) | null
  )?.response?.data as ReservationAPIError | undefined

  if (typeof data?.message === 'string' && /^[a-z-]+$/.test(data.message)) {
    return data.message
  }

  return null
}
